"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceService = void 0;
const operators_1 = require("rxjs/operators");
const http_1 = require("@angular/common/http");
const shared_1 = require("../../shared");
class InsuranceService extends shared_1.RestService {
    constructor() {
        super(...arguments);
        this.insuranceUrl = '/rest-api/account/insurance/v1/details';
        this.insuranceEligibilityUrl = '/rest-api/account/insurance/v2/eligibility/';
        this.addInsuranceFeatureV2Url = '/rest-api/account/insurance/v2/enroll';
        this.removeInsuranceFeatureUrl = '/rest-api/account/insurance/v1/unenroll/';
        this.insuranceTiersUrl = '/rest-api/account/insurance/v1/tiers?csn=';
        this.getAppleCareDetailsUrl = '/rest-services/web-wirelesscatalog-services/v1/devices/apple-care-info/';
        this.unbilledDeviceCoverageUrl = '/rest-api/account/insurance/v1/unbilled/';
        this.enrollUnbilledInsuranceUrl = '/rest-api/account/insurance/v1/enroll/unbilled/';
        // Authentication Service (AuthService)
        this.getOauthTokenUrl = '/rest-api/token/v1/login-status/';
    }
    getInsurance() {
        return this.get(this.insuranceUrl).pipe(operators_1.map((data) => data));
    }
    getInsuranceEligibility(subId) {
        return this.get(this.insuranceEligibilityUrl + subId);
    }
    addInsuranceFeature(subId, insuranceType) {
        const inputArgs = new http_1.HttpParams().set('subId', subId).set('insuranceType', insuranceType);
        return this.post(this.addInsuranceFeatureV2Url, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    removeInsuranceFeature(subId) {
        return this.delete(this.removeInsuranceFeatureUrl + subId).pipe(operators_1.map((data) => data));
    }
    getDeviceInsuranceTier(csn) {
        return this.get(this.insuranceTiersUrl + csn).pipe(operators_1.map((data) => data));
    }
    getInsuranceBySubscriptionId(subId) {
        return this.get(this.insuranceUrl + '/' + subId);
    }
    /**
     * @returns Observable of type TokenResponse - refresh token
    */
    refreshToken() {
        return this.get(this.getOauthTokenUrl).pipe(operators_1.map((res) => {
            this.oauthToken = res;
            return res;
        }));
    }
    getAppleCareInfo(esn, oauthToken) {
        let headers = new http_1.HttpHeaders();
        headers = headers.set('Client', 'WEB');
        if (oauthToken) {
            headers = headers.append('CS-SESSION-ID', oauthToken.sessionId);
            headers = headers.append('Authorization', ('bearer ' + oauthToken.token));
        }
        return this.get(this.getAppleCareDetailsUrl + esn, headers).pipe(operators_1.map((data) => data));
    }
    getUnbilledInsurance() {
        return this.get(this.unbilledDeviceCoverageUrl).pipe(operators_1.map((data) => data));
    }
    enrollUnbilledInsurance(content) {
        return this.post(this.enrollUnbilledInsuranceUrl, content, true).pipe(operators_1.map((data) => data));
    }
}
exports.InsuranceService = InsuranceService;
//# sourceMappingURL=insurance.service.js.map